var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53838 7.81538L13.5384 3.78461C13.723 3.6 13.723 3.32307 13.5384 3.13846L12.923 2.49231C12.7384 2.30769 12.4615 2.30769 12.2768 2.49231L8.24608 6.52307C8.123 6.64615 7.93838 6.64615 7.81531 6.52307L3.78454 2.46154C3.59992 2.27692 3.323 2.27692 3.13838 2.46154L2.49223 3.10769C2.30761 3.29231 2.30761 3.56923 2.49223 3.75384L6.523 7.78461C6.64608 7.90769 6.64608 8.09231 6.523 8.21538L2.46146 12.2769C2.27684 12.4615 2.27684 12.7385 2.46146 12.9231L3.10761 13.5692C3.29223 13.7538 3.56915 13.7538 3.75377 13.5692L7.78454 9.53846C7.90761 9.41538 8.09223 9.41538 8.21531 9.53846L12.2461 13.5692C12.4307 13.7538 12.7076 13.7538 12.8922 13.5692L13.5384 12.9231C13.723 12.7385 13.723 12.4615 13.5384 12.2769L9.53838 8.24615C9.41531 8.12307 9.41531 7.93846 9.53838 7.81538V7.81538Z",
    fill: "#0F7CAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.61c14f13f88c0d4f53134ee1ab36a5dc.svg";
export { ForwardRef as ReactComponent };